import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class LinkedinPromotionService {
  // Company LinkedIn Info
  getInfoByCompanyId(companyId) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/info/${companyId}`);
  }

  saveInfo(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "linkedin/promotion/info/save", body);
  }

  // Deals CRUD
  getDealsByCompanyId(companyId) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deals/${companyId}`);
  }

  addDeal(body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "linkedin/promotion/deals/add", body);
  }

  updateDeal(body) {
    return httpRequestAdmin.put(process.env.REACT_APP_BACKEND_API_URL + "linkedin/promotion/deals/update", body);
  }

  removeDeal(id) {
    return httpRequestAdmin.delete(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deals/remove/${id}`);
  }

  // Existing
  getTotalStats() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/total-stats`);
  }

  recoverDeal(id) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/recover/${id}`);
  }

  manualAdjustDeal(companyId, body) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + `linkedin/promotion/deal/manual-adjust/${companyId}`, body);
  }
}

export default new LinkedinPromotionService();
